var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenNPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.13,
    height: 36.13,
    viewBox: "0 0 36.13 36.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16761",
    "data-name": "Group 16761",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16670",
    "data-name": "Group 16670",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16669",
    "data-name": "Group 16669",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38766",
    "data-name": "Path 38766",
    d: "M18.042,6H6.343A3.343,3.343,0,0,0,3,9.343v23.4a3.343,3.343,0,0,0,3.343,3.343h23.4a3.343,3.343,0,0,0,3.343-3.343v-11.7",
    transform: "translate(-3 -2.455)",
    fill: "none",
    stroke: "#7e84a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38767",
    "data-name": "Path 38767",
    d: "M29.549,3.856a3.545,3.545,0,0,1,5.014,5.014L18.685,24.748,12,26.42l1.671-6.685Z",
    transform: "translate(-1.972 -2.818)",
    fill: "none",
    stroke: "#7e84a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenNPaper);
export default __webpack_public_path__ + "static/media/PenNPaper.cc28517d1163495d8025944f6d92506f.svg";
export { ForwardRef as ReactComponent };